import styled from '@emotion/styled'

export const BaseImage = styled.img({
  display: 'block',
  width: '100%',
  height: 'auto',
})
